<template>
  <AppContainer>
    <div>
      <EPageTitleMobile :title :description />

      <template v-if="type === 'checkbox' && model[index]">
        <EFormField :label="t(useTranslationPath(callerPath, 'hazards'))" fieldset>
          <template v-for="(item, checkboxIndex) in list" :key="checkboxIndex">
            <ECheckbox
              :id="`checkbox${checkboxIndex}`"
              v-model="model[index].tasks[checkboxIndex].value"
              :name="`checkbox${checkboxIndex}`"
              :label="item.name"
              :value="true"
              :disabled="isTaskActionDisabled(checkboxIndex)"
            />
          </template>
        </EFormField>
      </template>
      <EForm v-else-if="type === 'radio' && model[index]">
        <template v-for="(item, radioIndex) in list" :key="radioIndex">
          <EFormField
            :id="`radio${radioIndex}`"
            :name="`radio${radioIndex}`"
            :label="item.task"
            fieldset
          >
            <ERadioGroup v-model="model[index].tasks[radioIndex].value" inline>
              <ERadio
                :id="`radio${radioIndex}Yes`"
                :name="`radio${radioIndex}Yes`"
                :label="t(useTranslationPath(callerPath, 'yes'))"
                :value="true"
                :disabled="isTaskActionDisabled(radioIndex)"
              />
              <ERadio
                :id="`radio${radioIndex}No`"
                :name="`radio${radioIndex}No`"
                :label="t(useTranslationPath(callerPath, 'no'))"
                :value="false"
                :disabled="isTaskActionDisabled(radioIndex)"
              />
            </ERadioGroup>
          </EFormField>
        </template>
      </EForm>
      <EList v-else class="mt-4">
        <EListItem
          v-for="(item, listIndex) in list"
          :key="listIndex"
          :title="t(item.title)"
          :status="item.status"
          :status-variant="item.statusVariant"
          @click="emits('click', listIndex)"
        />
      </EList>
    </div>

    <template #bottom>
      <EButton
        :label="actionLabel"
        :disabled="isActionDisabled"
        block
        @click="emits('actionClick')"
      />
    </template>
  </AppContainer>
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useStartWorkCheckStore } from '@/stores/authenticated/StartWorkCheckStore.js'
import {
  EButton,
  ECheckbox,
  EForm,
  EFormField,
  EList,
  EListItem,
  EPageTitleMobile,
  ERadio,
  ERadioGroup,
} from '@expansivefm/eds'
import { isEmpty } from 'lodash'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  index: {
    type: Number,
    required: false,
    default: -1,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: false,
    default: '',
  },
  actionLabel: {
    type: String,
    required: true,
  },
  list: {
    type: Array,
    required: true,
  },
  type: {
    type: String,
    default: 'list',
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['click', 'actionClick'])

const model = defineModel({ type: Array, required: false, default: () => [] })

const { t } = useI18n()

const startWorkCheckStore = useStartWorkCheckStore()

const callerPath = 'components.workOrder.startWorkCheck.startWorkCheckList'

const getStartWorkCheckOffset = computed(() => props.index)

const isActionDisabled = computed(() => {
  let shouldBeDisabled = false

  if (props.isLoading) {
    return true
  }

  if (!isEmpty(startWorkCheckStore.checkTasks)) {
    if (getStartWorkCheckOffset.value === -1) {
      return props.list
        .map((section) => section.status === 'required')
        .some((status) => status === true)
    } else {
      shouldBeDisabled = startWorkCheckStore.checkTasks
        .at(getStartWorkCheckOffset.value)
        .tasks.filter((task) => !task.disabled)
        .some((task) => {
          if ('value' in task) {
            return task.value === null
          }

          return true
        })
    }
  }

  return shouldBeDisabled
})

const isTaskActionDisabled = (index) => {
  return (
    startWorkCheckStore.checkTasks.at(getStartWorkCheckOffset.value).tasks[index].disabled ?? false
  )
}
</script>
